import { render, staticRenderFns } from "./VDropdown.vue?vue&type=template&id=43fbf6b6"
import script from "./VDropdown.vue?vue&type=script&lang=js"
export * from "./VDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports